<template>
  <v-layout row wrap pa-3>
    <v-flex xs12 md8 wrap>
      <v-layout column main-section>
        <v-flex pt-3>
          <v-card-title>
            <!-- <h3 class="halfwhite-text">
                {{ $store.getters.getHeadingForBalanceBlock }}
              </h3> -->
            <v-icon>mdi-repeat</v-icon>
            <h4 class="headline halfwhite-text ml-2">Switch Organization</h4>
          </v-card-title>
          <v-flex v-if="!$store.getters.isCurrentOrgSet" mt-3 mx-3>
            <v-card color="white" class="rounded">
              <v-card-text>
                <div>
                  There is no active org available in your user profile, please
                  create a new org or switch to an existing org.
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-card color="white mt-3 mx-3" class="rounded" v-else>
            <v-card-title class="mb-0">
              <h4 class="subheading ml-1">
                Current Organization:
                <span class="font-weight-medium">
                  {{ $store.getters.getCurrentOrgName }}
                </span>
              </h4>
            </v-card-title>
            <v-card-text>
              <v-form
                v-model="FormValid"
                v-on:submit.prevent="switchOrg"
                ref="form"
              >
                <v-select
                  v-model="newOrg"
                  :rules="orgRules"
                  :items="$store.state.userSelf.orgs"
                  item-text="name"
                  item-value="subdomain"
                  label="Select organization to switch to"
                >
                  <template slot="selection" slot-scope="data">{{
                    data.item.name
                  }}</template>
                  <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        data.item.name
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title
                        >{{
                          isCurrentOrg(data.item.subdomain)
                            ? " (Current Organization)"
                            : ""
                        }}
                        {{
                          data.item.isActive ? "" : "(Status: Disabled)"
                        }}</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </template>
                </v-select>
                <div class="mt-3">
                  <v-btn
                    class="btn-rounded-medium white--text"
                    color="#d13b55"
                    @click.prevent="switchOrg"
                    :disabled="!FormValid"
                  >
                    Switch
                  </v-btn>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex></v-flex>
    <v-flex xs12 md3 px-3 mt-4 mr-2>
      <v-layout column wrap mt-4>
        <BalanceColumn></BalanceColumn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import validationRules from "@/js/validationRules.js";
import BalanceColumn from "@/components/BalanceColumn";

export default {
  name: "SwitchOrg",
  components: {
    BalanceColumn,
  },
  data() {
    return {
      newOrg: null,
      FormValid: true,
      orgRules: validationRules.requiredRules,
    };
  },
  computed: {},
  methods: {
    isCurrentOrg: function (subdomain) {
      return (
        subdomain ==
        ((this.$store.state.userSelf.currentOrg || {}).org || {}).subdomain
      );
    },
    switchOrg: function () {
      if (this.isCurrentOrg(this.newOrg)) {
        // Display Warning Message
        this.$store.commit("replaceSnackbar", {
          message:
            "Please select a different organization than your current one",
          messageType: "warning",
        });
        return;
      }

      // Disable form submission while async call takes place
      this.FormValid = false;

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Switching Organization...",
        messageType: "warning",
      });

      const params = { subdomain: this.newOrg };
      axios
        .post("/api/user/switchorg", params, this.$store.state.axiosConfig)
        .then((response) => {
          // Allow form submission and reset form
          this.FormValid = true;
          this.$refs.form.reset();

          // Commit user info to global
          this.$store.commit("setUserSelf", response.data);

          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Organization Switched.",
          });
        })
        .catch((e) => {
          // Allow form submission
          this.FormValid = true;

          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Organization was NOT switched.<br>Response: " +
              e.response.data.message +
              "<br>Error #NDI832",
            messageType: "error",
          });
        });
    },
  },
  beforeMount() {},
};
</script>
